import { useMobile } from '../../../../services/screenSize/ScreenSizeService';
import { StandardModal } from '../../../StandardModal/StandardModal';
import { PickerContentProps } from '../types';
import { ContentWrapper, MobileContent, List } from './PickerContent.styles';

export const PickerContent = <T extends unknown>({
  options,
  onClick,
  isOpen,
  onDismiss,
}: PickerContentProps<T>) => {
  const isMobile = useMobile();

  const optionsElements = options?.map((data, index) => (
    <List role="option" key={index} onClick={() => onClick?.(data.value)} dir={data.dir ?? 'ltr'}>
      {data.label}
    </List>
  ));

  return isMobile ? (
    <StandardModal role="listbox" isOpen={isOpen} onRequestClose={onDismiss}>
      <MobileContent role="listbox">{optionsElements}</MobileContent>
    </StandardModal>
  ) : (
    <ContentWrapper role="listbox">{optionsElements}</ContentWrapper>
  );
};
